import { render, staticRenderFns } from "./IconFolderRemoveSolid.vue?vue&type=template&id=18068a14"
import script from "./IconFolderRemoveSolid.vue?vue&type=script&lang=js"
export * from "./IconFolderRemoveSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports